import { render } from "./ProductDetail_AuditBusinessProfile.vue?vue&type=template&id=3537d613&scoped=true"
import script from "./ProductDetail_AuditBusinessProfile.vue?vue&type=script&lang=js"
export * from "./ProductDetail_AuditBusinessProfile.vue?vue&type=script&lang=js"

import "./ProductDetail_AuditBusinessProfile.vue?vue&type=style&index=0&id=3537d613&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3537d613"]])

export default __exports__